export enum UNIT_OF_MEASURE {
  HOUR,
  LINEAR_FEET,
  MILESTONE,
}
